import { UNDEFINED } from '../constants';

export default typeof window !== UNDEFINED && typeof document !== UNDEFINED;
